import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { map, switchMap } from "rxjs/operators";
import * as type from './actionTypes';
import * as UserToBillAction from './actions';
import { UserToBillService } from "./service";
import { IServerResponse } from "app/interface";

@Injectable()
export class UserToBillEffect {

    constructor(
        private action: Actions,
        private userToBillService: UserToBillService
    ) { }

    GetUserToBillList = createEffect(() => this.action.pipe(
        ofType(type.GET_USER_TO_BILL_LIST),
        switchMap((data) => this.userToBillService.getUserToBillList()),
        map((data: Array<any>) => new UserToBillAction.UserToBillList(data)
        )
    ));

    SaveUserToBill = createEffect(() => this.action.pipe(
        ofType(type.SAVE_USER_TO_BILL),
        switchMap((data: any) => this.userToBillService.saveUserToBill(data.payload)),
        map((data: IServerResponse) => new UserToBillAction.SaveUserToBillResp(data)
        )
    ));

    DeleteUserToBill = createEffect(() => this.action.pipe(
        ofType(type.DELETE_USER_TO_BILL),
        switchMap((data: any) => this.userToBillService.deleteUserToBill(data.payload)),
        map((data: IServerResponse) => new UserToBillAction.DeleteUserToBillResp(data)
        )
    ));
}
